<template>
  <v-autocomplete
    :data-testid="toKebabCase(field.label)"
    :class="{ required: field.required }"
    :model-value="uniqueModelValue"
    :rules="validationRules"
    :items="field.dropDownValues"
    v-bind="{ ...$props, ...$attrs }"
    @update:model-value="value => $emit('input', normalizeSelection(value))"
    density="compact"
    clearable
    open-on-clear
    hide-details="auto"
    :placeholder="field.label"
    :persistent-placeholder="persistentPlaceholder ? Boolean(field.placeholder) : false"
    multiple>
    <template #label>
      {{ t('customFields.forms.customFieldsForm.placeholders.chooseOneOrMoreOptions') }}
    </template>
  </v-autocomplete>
</template>

<script>
import customFieldTypeMixin from '@/modules/custom_fields/mixins/customFieldTypeMixin';
import { t, toKebabCase, uniqDropDownMultiSelectValues } from '@nova/core';

export default {
  methods: {
    t,
    toKebabCase,
    normalizeSelection(value) {
      return uniqDropDownMultiSelectValues(value);
    }
  },
  name: 'custom-field-dropdownmultiselect',
  mixins: [customFieldTypeMixin],
  computed: {
    uniqueModelValue() {
      return uniqDropDownMultiSelectValues(this.field.value);
    }
  }
};
</script>
